<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-16 10:14:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-25 16:02:49
-->
<template>
  <el-dialog
    class="addFromUserDialog"
    title="从监考员列表选择"
    top="5vh"
    :visible.sync="visible"
    width="960px"
  >
    <p class="select-num">
      已选：<span>{{ selectList.length }}人</span>
    </p>
    <table-list
      :search-form="searchForm"
      :data="userList"
      :columns="columns(this)"
      :options="{ selection: true, selectable: selectEvent }"
      @selectionChange="handleSelectionChange"
      @search="onSearch"
    ></table-list>
    <div class="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 搜索框配置
const searchForm = [
  {
    label: '姓名/手机号/身份证',
    prop: 'keyword',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'userName',
    label: '姓名',
    minWidth: 80,
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 100,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 150,
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: 150,
  },
]
import { userTeacherList, userTeacherAdd } from '@/api/exam'
import to from 'await-to'
import TableList from '@/components/TableList'
export default {
  name: 'AddFromUser',
  components: { TableList },
  data() {
    return {
      searchForm,
      columns,
      visible: false,
      userList: [],
      selectList: [],
    }
  },
  methods: {
    show() {
      this.visible = true
      this.getUserList()
    },
    async getUserList() {
      const [res, err] = await to(
        userTeacherList({ ...this.queryParams, planId: this.$route.params.id }),
      )
      if (err) return this.$message.warning(err.msg)
      this.userList = res.data
    },
    handleSelectionChange(row) {
      this.selectList = row
    },
    async save() {
      const [, err] = await to(
        userTeacherAdd({
          userIds: this.selectList.map(item => item.userId),
          planId: this.$route.params.id,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.visible = false
      this.$message.success('配置成功')
      this.$emit('success')
    },
    // 查询按钮
    onSearch(queryParams) {
      this.queryParams = queryParams
      this.getUserList()
    },
    selectEvent(row) {
      return !row.isInvigilateTeacher
    },
  },
}
</script>
<style lang="scss" scoped>
.addFromUserDialog {
  /deep/.el-dialog__body {
    position: relative;
    padding-top: 20px;
  }
  .select-num {
    position: absolute;
    left: 30px;
    top: 30px;
    font-size: 16px;
    font-weight: 400;
    color: #6f7986;
    span {
      color: #3671bf;
    }
  }
  /deep/.table-list {
    padding-top: 56px;
    position: relative;
    .table-search-bar {
      width: 400px;
      position: absolute;
      right: 0;
      top: 0;
      .form {
        padding: 0;
      }
    }
  }
  /deep/ .el-table__body-wrapper {
    // height: calc(100% - 102px) !important;
  }
  .footer {
    display: flex;
    padding-top: 16px;
    .el-button {
      &:first-child {
        margin-left: auto;
      }
    }
  }
}
</style>
